import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { StudyBase } from '../common/study-base';
import { CommonCheck } from '../../utils/common.check';
import { CommonEncrypt } from '../../utils/common.encrypt';
import { HttpServices } from '../../services/httpservices/http.service';
import { Router, ActivatedRoute } from "@angular/router";
import { GlobalVariable } from 'src/app/app.globalvariable';
import { SampleInfo } from "src/app/model/sampleInfo.model";
import { AlertComponent } from '../alert/alert.component';
import { isUndefined } from 'util';


@Component({
  selector: 'app-study',
  templateUrl: './study.component.html',
  styleUrls: ['./study.component.scss']
})
export class StudyComponent extends StudyBase {
  styleObj: any = [];
  message: any;
  // subscription: Subscription;

  bsDeleteModalRef: BsModalRef;
  bsModalRef: BsModalRef;


  public titer_P: any;
  public titer_C: any;
  public titer_PR3: any;
  public titer_MPO: any;

  public sampleList: any;
  public sampleInfo: SampleInfo = new SampleInfo();

  public zoomMultiple: number = 100;
  public showType: string = '1';
  public showTypeList: any = [];
  public showTypeList2: any = [];
  public errorMessage: string;

  public onLineCount: string = '1';
  
  public readonly: boolean;


  constructor(public modalService: BsModalService, public router: Router, private httpService: HttpServices,
    activeRoute: ActivatedRoute,) {
    super(modalService, router);

      this.readonly = false;
    this.showTypeList.push({ code: "1", name: "全部" });
    this.showTypeList.push({ code: "2", name: "正确" });
    this.showTypeList.push({ code: "3", name: "错误" });
    this.showTypeList2.push({ code: "1", name: "全部" });
    this.showTypeList2.push({ code: "2", name: "已完成" });
    this.showTypeList2.push({ code: "3", name: "未完成" });
    this.sampleInfo.curStage = activeRoute.snapshot.params["s_id"];
    

    this.sampleInfo.project_ID = activeRoute.snapshot.params["p_id"];
    this.sampleInfo.template_ID = activeRoute.snapshot.params["t_id"];

    
    this.sampleInfo.curSampleNO = "1";
    this.sampleInfo.curOrderNO = "1";

    this.getData ('');
     

  }

  getData (op) {
    
    this.readonly = false;
    if (this.sampleInfo.curStage == "2") {
      this.readonly = true;
    }
    //获取注册初始化信息
    this.httpService.studyInit(this.sampleInfo).subscribe(retObj => {
      if (retObj.errcode == '') {
        let retResult: any = retObj.resultInfo;
        //省份
        this.onLineCount = retResult['onLineCount'];
        this.sampleInfo = retResult['sampleInfo'];

        this.sampleList = this.sampleInfo.sampleList;
        this.titer_P = this.sampleInfo.diduMoto;
        this.titer_C = this.sampleInfo.diduMoto;
        this.titer_PR3 = this.sampleInfo.diduMoto;
        this.titer_MPO = this.sampleInfo.diduMoto;
        
        if (op == "sub") {
          if (parseInt(this.sampleInfo.answerCount) != parseInt(this.sampleInfo.allCount)) {
            this.alert('提醒', '请完成所有题目后再进行提交操作！', false);
          } else if (this.sampleInfo.curStage == '1') {
            this.alertForConfirm('提示', '提交成功，当前共有' + this.sampleInfo.doneOrder + '人完成所有题目。', false, "goHomeSub");
            // this.router.navigateByUrl("/home");
          } else if (this.sampleInfo.curStage == '3') {
            this.alertForConfirm('提示', '提交成功，当前共有' + this.sampleInfo.doneOrder + '人完成所有题目。', false, "studyresult");
            // this.router.navigateByUrl("/studyresult/" + this.sampleInfo.project_ID + "/" + this.sampleInfo.template_ID);
            // this.router.navigateByUrl("/studyresult");
          }
        }

        this.sampleList.forEach(element => {
          if (element.isSub == "1") {
            this.readonly = true;
          }          
        });

      } else if (retObj.errcode == '200999') {
        this.backLogin();
      } else if (retObj.errcode == '230002') {//未完成所有题目不提交

        let retResult: any = retObj.resultInfo;
        //省份
        this.sampleInfo = retResult['sampleInfo'];

        this.sampleList = this.sampleInfo.sampleList;
        this.titer_P = this.sampleInfo.diduMoto;
        this.titer_C = this.sampleInfo.diduMoto;
        this.titer_PR3 = this.sampleInfo.diduMoto;
        this.titer_MPO = this.sampleInfo.diduMoto;

        this.alert("提示", retObj.errmsg, false);
      } else if (retObj.errcode == '230001') {
        this.alert("提示", retObj.errmsg, false);
        this.router.navigateByUrl("/personalinfo");
      } else {
        this.alert("提示", retObj.errmsg, false);
      }
    },
      error => {
        console.error(error);
        this.alert('提示', "无法连接服务器，请稍后再试。", false);
      });
  }
  changeValue(op) {
    if (op == "resultReal") {
      if (this.sampleInfo.resultReal == "002") {
        this.sampleInfo.resultReal_P = "002";
        this.sampleInfo.resultReal_P_T = "";
        this.sampleInfo.resultReal_C = "002";
        this.sampleInfo.resultReal_C_T = "";
      }
  
    }
  }
  changeSample(sample_NO,order_NO) {

    this.sampleInfo.sampleNOForSave = this.sampleInfo.curSampleNO;
    this.sampleInfo.orderNOForSave = this.sampleInfo.curOrderNO;
    
    this.sampleInfo.curSampleNO = sample_NO;
    this.sampleInfo.curOrderNO = order_NO;

    this.getData ('');

  }
  change(op) {
    this.sampleInfo.sampleNOForSave = this.sampleInfo.curSampleNO;
    this.sampleInfo.orderNOForSave = this.sampleInfo.curOrderNO;
    this.sampleInfo.opFlag = op;
    if (op == "down") {
      if (this.sampleInfo.curStage != '2') {
        if (this.check() == false) {
          return;
        }    
      }  
      if (parseInt(this.sampleInfo.curOrderNO) < parseInt(this.sampleInfo.allCount)) {
        this.sampleInfo.curOrderNO = (String)(parseInt(this.sampleInfo.curOrderNO) + 1);
      }
    }
    if (op == "up") {
      if (parseInt(this.sampleInfo.curOrderNO) > 1) {
        this.sampleInfo.curOrderNO = (String)(parseInt(this.sampleInfo.curOrderNO) - 1);
      }
    }
    if (op == "sub") {
      if (this.sampleInfo.curStage != '2') {
        if (this.check() == false) {
          return;
        }
        const initialState = {
          title: "操作确认",
          content: "确认要提交结果吗？提交之后数据将无法修改。",
          confirmButtonShowFlag: true
        };
        // 显示弹框
        this.bsDeleteModalRef = this.modalService.show(AlertComponent, { initialState });
        // 子组件关闭后，触发的订阅函数
        this.modalService.onHidden.subscribe(() => {
    
        });
        this.bsDeleteModalRef.content.onClose = (msg: string) => {
          this.getData (op);
        }    
      }  
    } else {
      this.getData (op);
    }

  }
  check() {

    if (isUndefined(this.sampleInfo.resultReal) || this.sampleInfo.resultReal == '' || this.sampleInfo.resultReal == null) {
      this.alert('提醒', '请选择定性结果！', false);
      return false;
    }
    if (isUndefined(this.sampleInfo.resultReal_P) || this.sampleInfo.resultReal_P == '' || this.sampleInfo.resultReal_P == null) {
      this.alert('提醒', '请选择p-ANCA结果！', false);
      return false;
    }
    if (this.sampleInfo.resultReal_P == '001' && (isUndefined(this.sampleInfo.resultReal_P_T) || this.sampleInfo.resultReal_P_T == '' || this.sampleInfo.resultReal_P_T == null)) {
      this.alert('提醒', '请选择p-ANCA滴度！', false);
      return false;
    }
    if (isUndefined(this.sampleInfo.resultReal_C) || this.sampleInfo.resultReal_C == '' || this.sampleInfo.resultReal_C == null) {
      this.alert('提醒', '请选择c-ANCA结果！', false);
      return false;
    }
    if (this.sampleInfo.resultReal_C == '001' && (isUndefined(this.sampleInfo.resultReal_C_T) || this.sampleInfo.resultReal_C_T == '' || this.sampleInfo.resultReal_C_T == null)) {
      this.alert('提醒', '请选择c-ANCA滴度！', false);
      return false;
    }

    if (this.sampleInfo.resultReal == '002' && (this.sampleInfo.resultReal_P != '002' || this.sampleInfo.resultReal_C != '002')) {
      this.alert('提醒', '定性结果选择阴性，则p-ANCA、c-ANCA应该都为阴性！', false);
      return false;
    }
    if (this.sampleInfo.resultReal == '001' && this.sampleInfo.resultReal_P != '001' && this.sampleInfo.resultReal_C != '001') {
      this.alert('提醒', '定性结果选择阳性，则p-ANCA、c-ANCA至少一项选择阳性！', false);
      return false;
    }



  }

  alertForConfirm(alertTitle: string, alertContent: string, confirmButtonShowFlag: boolean, opFlag: string) {
    const initialState = {
      title: alertTitle,
      content: alertContent,
      confirmButtonShowFlag: confirmButtonShowFlag
    };
    // 显示弹框
    this.bsDeleteModalRef = this.modalService.show(AlertComponent, { initialState });
    // 子组件关闭后，触发的订阅函数
    this.modalService.onHidden.subscribe(() => {
      if (opFlag == "goHomeSub") {
        this.router.navigateByUrl("/home");
      }
      if (opFlag == "studyresult") {
        this.router.navigateByUrl("/studyresult/" + this.sampleInfo.project_ID + "/" + this.sampleInfo.template_ID);
      }
    });
    this.bsDeleteModalRef.content.onClose = (msg: string) => {
      if (opFlag == "goHome") {
        this.router.navigateByUrl("/home");
      }
      if (opFlag == "goChangePWD") {
        this.router.navigateByUrl("/password");
      }
      if (opFlag == "goLogin") {
        this.router.navigateByUrl("/login");
      }
    }
  }
  goHome() {
    this.alertForConfirm('操作确认', '确实要返回首页吗？', true, "goHome");
  }
  goChangePWD() {
    this.alertForConfirm('操作确认', '确实要修改密码吗？', true, "goChangePWD");
  }
  goLogin() {
    this.alertForConfirm('操作确认', '确实要返回登录页吗？', true, "goLogin");
  }
  changePic(picIndex) {
    if (picIndex == '1') {
      this.sampleInfo.curPicName = this.sampleInfo.pic1Name;
      this.sampleInfo.curPicSrc = this.sampleInfo.pic1Src;
    }
    if (picIndex == '2') {
      this.sampleInfo.curPicName = this.sampleInfo.pic2Name;
      this.sampleInfo.curPicSrc = this.sampleInfo.pic2Src;
    }
    if (picIndex == '3') {
      this.sampleInfo.curPicName = this.sampleInfo.pic3Name;
      this.sampleInfo.curPicSrc = this.sampleInfo.pic3Src;
    }
  }

  zoomIn() {
    if (this.zoomMultiple < 200) {
      this.zoomMultiple = this.zoomMultiple + 25;
    }
    this.styleObj = { 'width': this.zoomMultiple + '%'};
  }
  zoomOut() {
    if (this.zoomMultiple > 50) {
      this.zoomMultiple = this.zoomMultiple - 25;
    }
    this.styleObj = { 'width': this.zoomMultiple + '%'};
  }
  restore() {
    this.zoomMultiple = 100;
      this.styleObj = { 'width': this.zoomMultiple + '%'};
  }
}